<template>
  <div>
    <v-row align="end">
      <v-col cols="12">
        <v-range-slider
          label="Výber obdobia"
          v-model="filterORange"
          step="1"
          :min="minYear"
          :max="maxYear"
          ticks="always"
          tick-size="4"
          thumb-label="always"
        ></v-range-slider>
      </v-col>
    </v-row>

    <v-row v-if="loading">
      <v-col cols="12">
        <div class="text-center" style="width: 100%">
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <line-chart
          :chart-data="grafValues()"
          :options="grafOptions()"
        ></line-chart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
//import * as moment from "moment"
import * as Miscella from "@/plugins/miscella.js"
import LineChart from "./BarChart.js"

export default {
  data: function() {
    return {
      loading: false,
      filterORange: [this.minYear, this.maxYear],
      grafData: []
    }
  },
  components: { LineChart },
  props: {
    bod: {
      type: Object,
      required: true
    },
    minYear: {
      type: Number,
      required: true
    },
    maxYear: {
      type: Number,
      required: true
    }
  },
  computed: {},
  watch: {
    filterORange: {
      immediate: true,
      handler: function() {
        this.show()
      }
    }
  },
  methods: {
    grafValues: function() {
      let ret = ""
      ret = {
        labels: this.grafData.map(i => i.Datum),
        //labels: ["January", "February", "March", "April"],
        datasets: [
          {
            label: "Kolísanie hĺbky podzemnej vody",
            data: this.grafData.map(i => i.Hladina),
            backgroundColor: "#00bfff",
            borderColor: "#00bfff",
            pointRadius: "1",
            borderWidth: "1",
            pointStyle: "circle",
            fill: "false",
            type: "line",
            yAxisID: "y-axis-hladina"
          },
          {
            label: "Teplota podzemnej vody",
            data: this.grafData.map(i => i.Teplota),
            backgroundColor: "#935d5d",
            borderColor: "#935d5d",
            pointRadius: "1",
            borderWidth: "1",
            pointStyle: "circle",
            fill: "false",
            type: "line",
            yAxisID: "y-axis-teplota"
          }
        ]
      }
      return ret
    },
    grafOptions: function() {
      let ret = ""
      ret = {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: true,
          text: `Priebeh hĺbky hladiny a teploty podzemnej vody (${this.filterORange[0]} - ${this.filterORange[1]})`
        },
        legend: { display: true, position: "top" },
        scales: {
          xAxes: [
            {
              type: "time",
              //distribution: "series",
              time: {
                unit: "month"
              }
            }
          ],
          yAxes: [
            {
              type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
              display: true,
              position: "left",
              id: "y-axis-hladina",
              ticks: {
                reverse: true
              },
              scaleLabel: {
                display: true,
                labelString: "[m]"
              }
            },
            {
              type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
              display: true,
              position: "right",
              id: "y-axis-teplota",
              // grid line settings
              scaleLabel: {
                display: true,
                labelString: "[°C]"
              },
              gridLines: {
                drawOnChartArea: false // only want the grid lines for one axis to show up
              }
            }
          ]
        }
      }
      return ret
    },
    urlFetch: function() {
      let url = "/chart/hpv1"
      url += "?bodID=" + Miscella.normalizeString(this.bod.ID)
      url += "&rokOd=" + this.filterORange[0]
      url += "&rokDo=" + this.filterORange[1]
      return url
    },
    show: async function() {
      try {
        this.loading = true
        let response = await this.$axios.get(this.urlFetch())
        if (response.status === 200) {
          this.grafData = response.data.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        this.loading = false
      }
    }
  },
  mounted: function() {}
}

/*
//Download Chart Image
document.getElementById("download").addEventListener('click', function(){
  var url_base64jp = document.getElementById("lineChart").toDataURL("image/jpg");
  var a =  document.getElementById("download");
  a.href = url_base64jp;
});
*/
</script>
